import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';
import moment from 'moment';

import Delete from "@material-ui/icons/Delete";
import withStyles from '@material-ui/core/styles/withStyles';

import { setPageHeaderTextActionCreator } from 'plugins/store/reducers/common.reducer';
import {
	setAlertActionCreator,
} from 'plugins/store/reducers/common.reducer';
import { getCustomerRegistration } from 'services/customer-registration.service';
import { getContactCentersList } from 'services/contact-center.service';
import {
	updateAppointment,
	getAppointment,
	deleteAppointment,
} from 'services/appointment.service';
import layoutNames from 'utils/enums/layout-names.enum';

import withForm from 'hoc/withForm';
import SnackMessage from 'components/Snackbar/SnackMessage';
import ScheduledCallForm from 'components/Scheduler/ScheduledCallForm';
import AuditLog from 'components/AuditLog/AuditLog';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import NavPills from 'components/NavPills/NavPills';
import Button from 'components/CustomButtons/Button';
import RouteLeavingGuard from 'components/RouteLeavingGuard/RouteLeavingGuard';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import Tooltip from '@material-ui/core/Tooltip';

const styles = {
	deleteButtonWrapper: {
		position: 'absolute',
		width: '100%',
		top: '32px',
		textAlign: 'end',
	},
	deleteButton: {
		marginRight: '45px',
		zIndex: '100',
	},
	loadingIndicator: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
}

class EditAppointment extends Component {
	state = {
		activeTabIndex: 0,
		appointment: {},
		callCenterOptions: [],
		isLoading: true,
		defaults: {
			callPurpose: '',
			dateTime: null,
			callDuration: null,
			reminder: null,
			callTo: null,
			callCenter: null,
		}
	}

	availableDurations = [15, 30, 45];
	availableReminders = [5, 10, 15];

	prepareCallCenterProperties = async () => {
		const callCenters = await getContactCentersList();
		const sortedCallCenters = callCenters
			.sort((a, b) => {
				if (a.name > b.name) {
					return 1;
				}
				if (a.name < b.name) {
					return -1;
				}
				return 0;
			});
		this.setState({
			callCenterOptions: sortedCallCenters,
		});
	};

	getAppointmentsData = async () => {
		const { history, enqueueSnackbar } = this.props;
		try {
			const id = this.props.match?.params?.id;
			if (id) {
				const appointment = await getAppointment(id);

				if (!appointment) {
					enqueueSnackbar('Appointment has been removed', {
						content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
					});
					history.replace({
						pathname: `/${layoutNames.portal}/scheduler`,
					});
					return;
				}

				let selectedCustomer;

				try {
					selectedCustomer = await getCustomerRegistration(appointment.customerRegistrationId) || null;
				} catch (error) {
					console.log(error);
				}

				const selectedCallCenter = this.state.callCenterOptions.find((item) => item._id === appointment.callCenterId);

				this.props.setPageHeaderText(appointment.callPurpose);

				await this.setState({
					defaults: {
						callPurpose: { customNotification: appointment.callPurpose },
						dateTime: new Date(appointment.startTime),
						callDuration: appointment.callDuration,
						reminder: appointment.preCallReminderInterval,
						callTo: selectedCustomer,
						callCenter: selectedCallCenter,
					},
					appointment,
				});
			}
		} catch (error) {
			if (error.errorCode === 'GET_APPOINTMENT_NOT_ALLOWED') {
				const { history, enqueueSnackbar } = this.props;
				enqueueSnackbar('The appointment belongs to another user', {
					content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
				});
				history.replace({ pathname: `/${layoutNames.portal}/scheduler` });
				return;
			}
		}
		this.setState({
			isLoading: false,
		});
	}

	onNavPillsChange = (state) => {
		this.setState({
			activeTabIndex: state.activeTabIndex || 0,
		});
	}

	onBeforeNavPillsChange = async (callBack) => {
		const {
			formMethods: {
				formState: {
					isDirty,
				},
			},
			setAlert,
		} = this.props;

		if (this.state.activeTabIndex === 1) {
			await this.getAppointmentsData();
		}

		if (isDirty) {
			const warning = {
				type: 'warning',
				title: 'You have unsaved changes',
				message: 'Are you sure you want to leave the page?',
				confirmBtnText: 'Leave',
				cancelBtnText: 'Stay',
				onConfirm: async () => {
					this.resetForm();
					callBack();
					setAlert(null);
				},
				onCancel: () => {
					setAlert(null);
				}
			};
			setAlert(warning);
		} else {
			callBack();
		}
	};

	resetForm = () => {
		const { reset, trigger } = this.props.formMethods;
		reset();
		trigger();
	};

	componentDidMount() {
		this.initData();
	}


	initData = async () => {
		await this.prepareCallCenterProperties();
		await this.getAppointmentsData();
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
	}

	onSubmit = async (data, resetCallBack) => {
		const { history, enqueueSnackbar } = this.props;
		const { appointment: { id, type } } = this.state;
		try {
			const newAppointment = {}
			if (type === 'Call') {
				data.dateTime && (newAppointment.startTime = data.dateTime.toISOString());
				data.callCenter && (newAppointment.callCenterId = data.callCenter._id);
			}

			await updateAppointment(newAppointment, id);
			resetCallBack();
			history.replace({
				pathname: `/${layoutNames.portal}/scheduler`,
			});
		} catch (e) {
			enqueueSnackbar(e.resolvedErrorMessage, {
				content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
			});
		}
	}

	onError = () => {
		const { enqueueSnackbar } = this.props;
		const errorMessage = ['Appointment not saved.', 'Due to validation error(s)'];
		enqueueSnackbar(errorMessage, {
			content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
		});
	}

	handleDelete = () => {
		const {
			history,
			enqueueSnackbar,
			setAlert,
		} = this.props;

		const { appointment: { id, } } = this.state;

		const deleteNotifications = {
			type: 'warning',
			title: 'Do you want to remove Appointment?',
			message: 'This action can not be undone',
			confirmBtnText: 'REMOVE',
			onConfirm: async () => {
				setAlert(null);
				try {
					await deleteAppointment(id);
					history.replace({
						pathname: `/${layoutNames.portal}/scheduler`,
					});
					enqueueSnackbar(
						'Appointment successfully removed',
						{
							content: (key, message) => (
								<SnackMessage
									id={key}
									message={message}
									color="success"
								/>
							),
						}
					);
				} catch (e) {
					enqueueSnackbar(e.resolvedErrorMessage, {
						content: (key, message) => (
							<SnackMessage
								id={key}
								message={message}
								color="danger"
							/>
						),
					});
				}
			},
			onCancel: () => {
				setAlert(null);
			},
		};
		setAlert(deleteNotifications);
	}

	render() {
		const {
			appointment: {
				preCallReminderSent,
				startTime,
				createdBy,
				createdAt,
				modifiedBy,
				updatedAt,
			}
		} = this.state;

		const isInPast = moment().isAfter(moment(startTime));

		const {
			classes,
			history,
			formMethods,
			formMethods: {
				formState: {
					isDirty,
				},
			},
		} = this.props;

		return (
			<>
				{
					this.state.isLoading && <div className={classes.loadingIndicator}><LoadingIndicator /></div>
				}
				{!this.state.isLoading &&
					<GridContainer>
						<GridItem xs={12} sm={12} md={12}>
							<Card>
								<CardBody>
									<div className={classes.deleteButtonWrapper}>
										<Tooltip title="Remove Appointment">
											<Button
												className={classes.deleteButton}
												color="transparent"
												simple
												aria-label="Remove"
												justIcon
												onClick={this.handleDelete}
											>
												<Delete />
											</Button>
										</Tooltip>
									</div>
									<NavPills
										color="warning"
										onNavPillsChange={this.onNavPillsChange}
										onBeforeNavPillsChange={this.onBeforeNavPillsChange}
										tabs={[
											{
												tabButton: "Details",
												tabContent: (
													<div className="form">

														<ScheduledCallForm
															formMethods={formMethods}
															callCenterOptions={this.state.callCenterOptions}
															onSubmit={this.onSubmit}
															onError={this.onError}
															isEdit={true}
															defaults={this.state.defaults}
															isReminderSent={preCallReminderSent}
															isInPast={isInPast}
														/>

														<RouteLeavingGuard
															when={isDirty}
															navigate={path => history.push(path)}
															shouldBlockNavigation={() => {
																if (isDirty) {
																	return true;
																}
																return false
															}}
														/>
													</div>
												)
											},
											{
												tabButton: "Audit Log",
												tabContent: (
													<AuditLog
														createdBy={createdBy}
														createdAt={createdAt}
														modifiedBy={modifiedBy}
														modifiedAt={updatedAt}
													/>
												)
											}
										]}
									/>
								</CardBody>
							</Card>
						</GridItem>
					</GridContainer>
				}
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		currentUserEmail: state.auth.auth?.email,
		currentUserId: state.auth.auth?.id,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setAlert: bindActionCreators(setAlertActionCreator, dispatch),
	setPageHeaderText: bindActionCreators(setPageHeaderTextActionCreator, dispatch),
});

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withSnackbar,
	withStyles(styles),
	withForm,
	withRouter
)(EditAppointment);
